<template>

  <vx-card :title="$t('class-room.course-outline-desc')" class="mb-4" collapse-action>

    <template slot="actions">
      <vx-tooltip :text="$t('class-room.course-outline-edit')" v-if="local.courseOutline">
        <vs-button @click="onOpenCourseOutlineClick" color="dark" icon="icon-edit" icon-pack="feather" radius
                   type="flat"
        ></vs-button>
      </vx-tooltip>

    </template>

    <div class="text-center mb-2 text-nline">
      <div v-if="local.selectedSubject">
        <h4>{{ local.selectedSubject.code }}</h4>
        <vs-popup :active.sync="popupCourseOutline" :title="$t('class-room.course-outline-desc')"
                  class="holamundo" fullscreen>
          <div v-if="local.courseOutline">
            <course-outline-info
              :id="local.courseOutline.id"
              :mode="'edit'"
            />
          </div>
        </vs-popup>
      </div>
      <h4 v-else>-</h4>

      <p class="text-grey" v-if="local.selectedSubject">{{ local.selectedSubject.nameLocal }}</p>
      <p v-else>-</p>

    </div>

    <ul>
      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
              <span class="flex items-center">
                <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-units-qty') }}</span>
              </span>
        <span :class="local.courseOutline.courseOutlineUnits.length === 0 ? 'text-danger':''"
              v-if="local.courseOutline">
                {{ local.courseOutline.courseOutlineUnits.length }}
              </span>
        <span v-else>0</span>
      </li>

      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <feather-icon icon="VideoIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                  <span
                    class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-qty') }}</span>
                </span>
        <span :class="totalVdoQty === 0 ? 'text-danger':''" v-if="local.courseOutline">
                {{ totalVdoQty }}
              </span>
        <span v-else>0</span>
      </li>

      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <feather-icon icon="FilmIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                  <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-total-length') }}</span>
                </span>
        <span :class="totalVdoLength === '00:00:00' ? 'text-danger':''"
              v-if="local.courseOutline">{{ totalVdoLength }}</span>
        <span v-else>0</span>
      </li>

    </ul>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {hasVideo} from "@/utils/video-source";

  export default {
    components: {
      CourseOutlineInfo: () => import('@/views/pages/Courses/CourseOutlineInfo'),
    },
    data() {
      return {
        local: state.local,
        store: state.store,
        form: state.local.form,

        popupCourseOutline: false,
      }
    },
    computed: {
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.local.selectedVdoSet) {
          totalVdoLength = secondToHHMMSSFormat(this.local.selectedVdoSet.totalVdoLength);
        }
        return totalVdoLength;
      },
      // hasVideo, not vdoStreamPath: Bunny topics have no vdoStreamPath and
      // were being counted as no video at all.
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.local.selectedVdoSet) {
          this.local.selectedVdoSet.vdoSetUnits.forEach(vdoUnit => {
            if (vdoUnit.vdoSetTopics && vdoUnit.vdoSetTopics.length > 0) {
              vdoUnit.vdoSetTopics.forEach(vdoTopic => {
                totalVdoQty += hasVideo(vdoTopic) ? 1 : 0;
              })
            }
          });
        }
        return totalVdoQty;
      },
    },
    methods: {
      onOpenCourseOutlineClick() {
        this.popupCourseOutline = true;
      },
    },
  }
</script>

<style scoped>
</style>
